import { colorUseCases, css, getColorScaleValueByUseCase } from "@vitality-ds/system";
import SIZE from "../constants/size";
import TRANSITION from "../constants/transitions";
var text = colorUseCases.text,
  backgrounds = colorUseCases.backgrounds,
  borders = colorUseCases.borders;
var DURATION_MS = TRANSITION.DURATION_MS,
  TIMING_FUNCTION = TRANSITION.TIMING_FUNCTION;
var TRACK_WIDTH = SIZE.TRACK_WIDTH,
  TRACK_HEIGHT = SIZE.TRACK_HEIGHT;
export default css({
  all: "unset",
  boxSizing: "border-box",
  userSelect: "none",
  padding: 4,
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "flex-end",
  fontSize: "$body",
  lineHeight: 1,
  margin: "0",
  outline: "none",
  transition: "background-color ".concat(DURATION_MS, "ms ").concat(TIMING_FUNCTION),
  borderRadius: "$rounded",
  position: "relative",
  cursor: "pointer",
  color: getColorScaleValueByUseCase("neutral", text.onSolidBackgrounds),
  backgroundColor: getColorScaleValueByUseCase("neutral", backgrounds.uiElementSolid),
  "&[data-disabled]": {
    cursor: "not-allowed",
    "&, &:hover": {
      backgroundColor: getColorScaleValueByUseCase("neutral", backgrounds.uiElementSolid_disabled),
      color: getColorScaleValueByUseCase("neutral", text.disabled)
    }
  },
  "&:hover": {
    backgroundColor: getColorScaleValueByUseCase("neutral", backgrounds.uiElementSolid_hovered)
  },
  "&:focus-visible": {
    "&:not([data-disabled])": {
      boxShadow: "0 0 0 2px ".concat(getColorScaleValueByUseCase("neutral", backgrounds.app), ", 0 0 0 4px ").concat(getColorScaleValueByUseCase("primary", borders.focusRing))
    }
  },
  variants: {
    size: {
      "1": {
        width: TRACK_WIDTH,
        height: TRACK_HEIGHT
      }
    },
    checked: {
      "true": {
        justifyContent: "flex-start",
        backgroundColor: getColorScaleValueByUseCase("primary", backgrounds.uiElementSolid),
        "&:hover": {
          backgroundColor: getColorScaleValueByUseCase("primary", backgrounds.uiElementSolid_active)
        },
        "&[data-disabled]": {
          "&, &:hover": {
            backgroundColor: getColorScaleValueByUseCase("neutral", backgrounds.uiElementSolid_disabled),
            color: getColorScaleValueByUseCase("neutral", text.disabled)
          }
        }
      }
    }
  },
  defaultVariants: {
    size: "1"
  }
});